// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/service_account.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Subject } from "./identity_pb.js";

/**
 * @generated from message gitpod.v1.CreateServiceAccountRequest
 */
export class CreateServiceAccountRequest extends Message<CreateServiceAccountRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * valid_until specifies when this service account expires.
   * Note: In the current design, the service account itself has an expiry.
   * All authentication using this service account will fail after this time.
   *
   * @generated from field: google.protobuf.Timestamp valid_until = 3;
   */
  validUntil?: Timestamp;

  constructor(data?: PartialMessage<CreateServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "valid_until", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountRequest {
    return new CreateServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountRequest {
    return new CreateServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountRequest {
    return new CreateServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountRequest | PlainMessage<CreateServiceAccountRequest> | undefined, b: CreateServiceAccountRequest | PlainMessage<CreateServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateServiceAccountResponse
 */
export class CreateServiceAccountResponse extends Message<CreateServiceAccountResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;

  constructor(data?: PartialMessage<CreateServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountResponse {
    return new CreateServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountResponse {
    return new CreateServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountResponse {
    return new CreateServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountResponse | PlainMessage<CreateServiceAccountResponse> | undefined, b: CreateServiceAccountResponse | PlainMessage<CreateServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountsRequest
 */
export class ListServiceAccountsRequest extends Message<ListServiceAccountsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains options for filtering the list of service accounts.
   *
   * @generated from field: gitpod.v1.ListServiceAccountsRequest.Filter filter = 2;
   */
  filter?: ListServiceAccountsRequest_Filter;

  constructor(data?: PartialMessage<ListServiceAccountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListServiceAccountsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountsRequest {
    return new ListServiceAccountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountsRequest {
    return new ListServiceAccountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountsRequest {
    return new ListServiceAccountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountsRequest | PlainMessage<ListServiceAccountsRequest> | undefined, b: ListServiceAccountsRequest | PlainMessage<ListServiceAccountsRequest> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountsRequest.Filter
 */
export class ListServiceAccountsRequest_Filter extends Message<ListServiceAccountsRequest_Filter> {
  /**
   * include_suspended includes suspended (soft-deleted) service accounts in the response.
   * By default, suspended service accounts are excluded.
   *
   * @generated from field: bool include_suspended = 1;
   */
  includeSuspended = false;

  constructor(data?: PartialMessage<ListServiceAccountsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "include_suspended", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountsRequest_Filter {
    return new ListServiceAccountsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountsRequest_Filter {
    return new ListServiceAccountsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountsRequest_Filter {
    return new ListServiceAccountsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountsRequest_Filter | PlainMessage<ListServiceAccountsRequest_Filter> | undefined, b: ListServiceAccountsRequest_Filter | PlainMessage<ListServiceAccountsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountsResponse
 */
export class ListServiceAccountsResponse extends Message<ListServiceAccountsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ServiceAccount service_accounts = 2;
   */
  serviceAccounts: ServiceAccount[] = [];

  constructor(data?: PartialMessage<ListServiceAccountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "service_accounts", kind: "message", T: ServiceAccount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountsResponse {
    return new ListServiceAccountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountsResponse {
    return new ListServiceAccountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountsResponse {
    return new ListServiceAccountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountsResponse | PlainMessage<ListServiceAccountsResponse> | undefined, b: ListServiceAccountsResponse | PlainMessage<ListServiceAccountsResponse> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetServiceAccountRequest
 */
export class GetServiceAccountRequest extends Message<GetServiceAccountRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  constructor(data?: PartialMessage<GetServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetServiceAccountRequest {
    return new GetServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetServiceAccountRequest {
    return new GetServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetServiceAccountRequest {
    return new GetServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetServiceAccountRequest | PlainMessage<GetServiceAccountRequest> | undefined, b: GetServiceAccountRequest | PlainMessage<GetServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(GetServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetServiceAccountResponse
 */
export class GetServiceAccountResponse extends Message<GetServiceAccountResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;

  constructor(data?: PartialMessage<GetServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetServiceAccountResponse {
    return new GetServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetServiceAccountResponse {
    return new GetServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetServiceAccountResponse {
    return new GetServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetServiceAccountResponse | PlainMessage<GetServiceAccountResponse> | undefined, b: GetServiceAccountResponse | PlainMessage<GetServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(GetServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateServiceAccountRequest
 */
export class UpdateServiceAccountRequest extends Message<UpdateServiceAccountRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  /**
   * Optional fields for update
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Note: valid_until is immutable and cannot be updated
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateServiceAccountRequest {
    return new UpdateServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateServiceAccountRequest {
    return new UpdateServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateServiceAccountRequest {
    return new UpdateServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateServiceAccountRequest | PlainMessage<UpdateServiceAccountRequest> | undefined, b: UpdateServiceAccountRequest | PlainMessage<UpdateServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(UpdateServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateServiceAccountResponse
 */
export class UpdateServiceAccountResponse extends Message<UpdateServiceAccountResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;

  constructor(data?: PartialMessage<UpdateServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateServiceAccountResponse {
    return new UpdateServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateServiceAccountResponse {
    return new UpdateServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateServiceAccountResponse {
    return new UpdateServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateServiceAccountResponse | PlainMessage<UpdateServiceAccountResponse> | undefined, b: UpdateServiceAccountResponse | PlainMessage<UpdateServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(UpdateServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteServiceAccountRequest
 */
export class DeleteServiceAccountRequest extends Message<DeleteServiceAccountRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  constructor(data?: PartialMessage<DeleteServiceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteServiceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteServiceAccountRequest {
    return new DeleteServiceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteServiceAccountRequest {
    return new DeleteServiceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteServiceAccountRequest {
    return new DeleteServiceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteServiceAccountRequest | PlainMessage<DeleteServiceAccountRequest> | undefined, b: DeleteServiceAccountRequest | PlainMessage<DeleteServiceAccountRequest> | undefined): boolean {
    return proto3.util.equals(DeleteServiceAccountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteServiceAccountResponse
 */
export class DeleteServiceAccountResponse extends Message<DeleteServiceAccountResponse> {
  constructor(data?: PartialMessage<DeleteServiceAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteServiceAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteServiceAccountResponse {
    return new DeleteServiceAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteServiceAccountResponse {
    return new DeleteServiceAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteServiceAccountResponse {
    return new DeleteServiceAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteServiceAccountResponse | PlainMessage<DeleteServiceAccountResponse> | undefined, b: DeleteServiceAccountResponse | PlainMessage<DeleteServiceAccountResponse> | undefined): boolean {
    return proto3.util.equals(DeleteServiceAccountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateServiceAccountAccessTokenRequest
 */
export class CreateServiceAccountAccessTokenRequest extends Message<CreateServiceAccountAccessTokenRequest> {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId = "";

  constructor(data?: PartialMessage<CreateServiceAccountAccessTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountAccessTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountAccessTokenRequest {
    return new CreateServiceAccountAccessTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountAccessTokenRequest {
    return new CreateServiceAccountAccessTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountAccessTokenRequest {
    return new CreateServiceAccountAccessTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountAccessTokenRequest | PlainMessage<CreateServiceAccountAccessTokenRequest> | undefined, b: CreateServiceAccountAccessTokenRequest | PlainMessage<CreateServiceAccountAccessTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountAccessTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateServiceAccountAccessTokenResponse
 */
export class CreateServiceAccountAccessTokenResponse extends Message<CreateServiceAccountAccessTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<CreateServiceAccountAccessTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountAccessTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountAccessTokenResponse {
    return new CreateServiceAccountAccessTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountAccessTokenResponse {
    return new CreateServiceAccountAccessTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountAccessTokenResponse {
    return new CreateServiceAccountAccessTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountAccessTokenResponse | PlainMessage<CreateServiceAccountAccessTokenResponse> | undefined, b: CreateServiceAccountAccessTokenResponse | PlainMessage<CreateServiceAccountAccessTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountAccessTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ServiceAccount
 */
export class ServiceAccount extends Message<ServiceAccount> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.Subject creator = 5;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp valid_until = 7;
   */
  validUntil?: Timestamp;

  /**
   * suspended indicates whether the service account has been deleted (soft-delete).
   * Suspended service accounts cannot be used for authentication.
   *
   * @generated from field: bool suspended = 8;
   */
  suspended = false;

  constructor(data?: PartialMessage<ServiceAccount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ServiceAccount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "creator", kind: "message", T: Subject },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "valid_until", kind: "message", T: Timestamp },
    { no: 8, name: "suspended", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ServiceAccount {
    return new ServiceAccount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ServiceAccount {
    return new ServiceAccount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ServiceAccount {
    return new ServiceAccount().fromJsonString(jsonString, options);
  }

  static equals(a: ServiceAccount | PlainMessage<ServiceAccount> | undefined, b: ServiceAccount | PlainMessage<ServiceAccount> | undefined): boolean {
    return proto3.util.equals(ServiceAccount, a, b);
  }
}

/**
 * ServiceAccountToken represents metadata about a service account token.
 * The actual token value is only returned once during creation.
 *
 * @generated from message gitpod.v1.ServiceAccountToken
 */
export class ServiceAccountToken extends Message<ServiceAccountToken> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string service_account_id = 2;
   */
  serviceAccountId = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_used = 7;
   */
  lastUsed?: Timestamp;

  constructor(data?: PartialMessage<ServiceAccountToken>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ServiceAccountToken";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creator", kind: "message", T: Subject },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "expires_at", kind: "message", T: Timestamp },
    { no: 7, name: "last_used", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ServiceAccountToken {
    return new ServiceAccountToken().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ServiceAccountToken {
    return new ServiceAccountToken().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ServiceAccountToken {
    return new ServiceAccountToken().fromJsonString(jsonString, options);
  }

  static equals(a: ServiceAccountToken | PlainMessage<ServiceAccountToken> | undefined, b: ServiceAccountToken | PlainMessage<ServiceAccountToken> | undefined): boolean {
    return proto3.util.equals(ServiceAccountToken, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateServiceAccountTokenRequest
 */
export class CreateServiceAccountTokenRequest extends Message<CreateServiceAccountTokenRequest> {
  /**
   * @generated from field: string description = 1;
   */
  description = "";

  /**
   * valid_for specifies how long the token should be valid.
   * Maximum is 90 days. The actual expiry is capped to the service account's expiry.
   *
   * @generated from field: google.protobuf.Duration valid_for = 2;
   */
  validFor?: Duration;

  constructor(data?: PartialMessage<CreateServiceAccountTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "valid_for", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountTokenRequest {
    return new CreateServiceAccountTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountTokenRequest {
    return new CreateServiceAccountTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountTokenRequest {
    return new CreateServiceAccountTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountTokenRequest | PlainMessage<CreateServiceAccountTokenRequest> | undefined, b: CreateServiceAccountTokenRequest | PlainMessage<CreateServiceAccountTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateServiceAccountTokenResponse
 */
export class CreateServiceAccountTokenResponse extends Message<CreateServiceAccountTokenResponse> {
  /**
   * token is the actual JWT token value. This is only returned once during creation.
   *
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * service_account_token contains the token metadata.
   *
   * @generated from field: gitpod.v1.ServiceAccountToken service_account_token = 2;
   */
  serviceAccountToken?: ServiceAccountToken;

  constructor(data?: PartialMessage<CreateServiceAccountTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateServiceAccountTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "service_account_token", kind: "message", T: ServiceAccountToken },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateServiceAccountTokenResponse {
    return new CreateServiceAccountTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateServiceAccountTokenResponse {
    return new CreateServiceAccountTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateServiceAccountTokenResponse {
    return new CreateServiceAccountTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateServiceAccountTokenResponse | PlainMessage<CreateServiceAccountTokenResponse> | undefined, b: CreateServiceAccountTokenResponse | PlainMessage<CreateServiceAccountTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateServiceAccountTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountTokensRequest
 */
export class ListServiceAccountTokensRequest extends Message<ListServiceAccountTokensRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListServiceAccountTokensRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountTokensRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountTokensRequest {
    return new ListServiceAccountTokensRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountTokensRequest {
    return new ListServiceAccountTokensRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountTokensRequest {
    return new ListServiceAccountTokensRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountTokensRequest | PlainMessage<ListServiceAccountTokensRequest> | undefined, b: ListServiceAccountTokensRequest | PlainMessage<ListServiceAccountTokensRequest> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountTokensRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListServiceAccountTokensResponse
 */
export class ListServiceAccountTokensResponse extends Message<ListServiceAccountTokensResponse> {
  /**
   * @generated from field: repeated gitpod.v1.ServiceAccountToken tokens = 1;
   */
  tokens: ServiceAccountToken[] = [];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  constructor(data?: PartialMessage<ListServiceAccountTokensResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListServiceAccountTokensResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tokens", kind: "message", T: ServiceAccountToken, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListServiceAccountTokensResponse {
    return new ListServiceAccountTokensResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListServiceAccountTokensResponse {
    return new ListServiceAccountTokensResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListServiceAccountTokensResponse {
    return new ListServiceAccountTokensResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListServiceAccountTokensResponse | PlainMessage<ListServiceAccountTokensResponse> | undefined, b: ListServiceAccountTokensResponse | PlainMessage<ListServiceAccountTokensResponse> | undefined): boolean {
    return proto3.util.equals(ListServiceAccountTokensResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetServiceAccountTokenRequest
 */
export class GetServiceAccountTokenRequest extends Message<GetServiceAccountTokenRequest> {
  /**
   * @generated from field: string service_account_token_id = 1;
   */
  serviceAccountTokenId = "";

  constructor(data?: PartialMessage<GetServiceAccountTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetServiceAccountTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_token_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetServiceAccountTokenRequest {
    return new GetServiceAccountTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetServiceAccountTokenRequest {
    return new GetServiceAccountTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetServiceAccountTokenRequest {
    return new GetServiceAccountTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetServiceAccountTokenRequest | PlainMessage<GetServiceAccountTokenRequest> | undefined, b: GetServiceAccountTokenRequest | PlainMessage<GetServiceAccountTokenRequest> | undefined): boolean {
    return proto3.util.equals(GetServiceAccountTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetServiceAccountTokenResponse
 */
export class GetServiceAccountTokenResponse extends Message<GetServiceAccountTokenResponse> {
  /**
   * @generated from field: gitpod.v1.ServiceAccountToken token = 1;
   */
  token?: ServiceAccountToken;

  constructor(data?: PartialMessage<GetServiceAccountTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetServiceAccountTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "message", T: ServiceAccountToken },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetServiceAccountTokenResponse {
    return new GetServiceAccountTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetServiceAccountTokenResponse {
    return new GetServiceAccountTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetServiceAccountTokenResponse {
    return new GetServiceAccountTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetServiceAccountTokenResponse | PlainMessage<GetServiceAccountTokenResponse> | undefined, b: GetServiceAccountTokenResponse | PlainMessage<GetServiceAccountTokenResponse> | undefined): boolean {
    return proto3.util.equals(GetServiceAccountTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteServiceAccountTokenRequest
 */
export class DeleteServiceAccountTokenRequest extends Message<DeleteServiceAccountTokenRequest> {
  /**
   * @generated from field: string service_account_token_id = 1;
   */
  serviceAccountTokenId = "";

  constructor(data?: PartialMessage<DeleteServiceAccountTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteServiceAccountTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account_token_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteServiceAccountTokenRequest {
    return new DeleteServiceAccountTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteServiceAccountTokenRequest {
    return new DeleteServiceAccountTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteServiceAccountTokenRequest {
    return new DeleteServiceAccountTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteServiceAccountTokenRequest | PlainMessage<DeleteServiceAccountTokenRequest> | undefined, b: DeleteServiceAccountTokenRequest | PlainMessage<DeleteServiceAccountTokenRequest> | undefined): boolean {
    return proto3.util.equals(DeleteServiceAccountTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteServiceAccountTokenResponse
 */
export class DeleteServiceAccountTokenResponse extends Message<DeleteServiceAccountTokenResponse> {
  constructor(data?: PartialMessage<DeleteServiceAccountTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteServiceAccountTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteServiceAccountTokenResponse {
    return new DeleteServiceAccountTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteServiceAccountTokenResponse {
    return new DeleteServiceAccountTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteServiceAccountTokenResponse {
    return new DeleteServiceAccountTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteServiceAccountTokenResponse | PlainMessage<DeleteServiceAccountTokenResponse> | undefined, b: DeleteServiceAccountTokenResponse | PlainMessage<DeleteServiceAccountTokenResponse> | undefined): boolean {
    return proto3.util.equals(DeleteServiceAccountTokenResponse, a, b);
  }
}

